module.exports = __webpack_public_path__ + "assets/557f09d3496ec4c05aeb93d036f23720.png";